import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { Swiper } from "swiper";
import * as styles from "../styles/pages/index.module.scss";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleUp } from "@fortawesome/pro-regular-svg-icons";

import { Banner } from "../components/Banner/Banner";
import { StyledLink } from "../components/Buttons/StyledLink/StyledLink";
import { Card } from "../components/Card/Card";
import { Carousel } from "../components/Carousel/Carousel";
import { CarouselControlsPic } from "../components/Carousel/CarouselControlsPic";
import { CarouselPic } from "../components/Carousel/CarouselPic";
import { Layout } from "../components/Layout/Layout";
import { Subtitle } from "../components/Subtitle/Subtitle";
import { Text } from "../components/Text/Text";
import { Title } from "../components/Title/Title";
import { Price } from "../components/Price/Price";
import { Contact } from "../components/Contact/Contact";
import { ContactD } from "../components/Contact/ContactD";
import { CarouselD } from "../components/Carousel/CarouselD";
import { CarouselControlsD } from "../components/Carousel/CarouselControlsD";
import { CarouselControls } from "../components/Carousel/CarouselControls";
import { MapAccordion } from "../components/Accordion/MapAccordion";

import { TITLE } from "../../static/contents/title";
import { SUBTITLE } from "../../static/contents/subtitle";
import { PRICE, TEXT } from "../../static/contents/text";
import { BannerD } from "../components/Banner/BannerD";

import pdfProgramme from "../../static/pdf/EAO-SPBR_synopsis-V2.pdf";
import pdfinformation from "../../static/pdf/EAO-SPRINGBREAK-GeneralConditions _v5.pdf";

const IndexPage: React.FC = () => {
  const [swiper, setSwiper] = useState<Swiper>();
  const [swiperD, setSwiperD] = useState<Swiper>();
  const [swiperPic, setSwiperPic] = useState<Swiper>();
  const [ssr, setSSR] = useState(false);

  const programme = pdfProgramme;

  useEffect(() => {
    if (typeof window !== "undefined") {
      console.log(`window`, window);
      window.gtag &&
        window.gtag("set", {
          cookie_flags: "SameSite=None;Secure",
        });
    }
  }, []);

  return (
    <Layout>
      <div className={styles.homeTitle} id="top">
        <Title text={TITLE.title1} className={styles.title} />
      </div>

      <div className={styles.triCard}>
        <div className={styles.imageWelcome}>
          <StaticImage
            src={"../../static/images/home-students-1024x427.png"}
            alt={"welcome"}
            objectFit="cover"
            objectPosition={"center"}
          />
        </div>
        <div className={styles.imageWelcomeD}>
          <StaticImage
            src={"../../static/images/RFH-6672.jpg"}
            alt={"welcome"}
            objectFit="cover"
            objectPosition={"center"}
            className={styles.imageD}
          />
        </div>

        <div className={styles.sectionOne}>
          <div className={styles.blockText}>
            <Subtitle text={SUBTITLE.subtitle1} className={styles.subtitle} />
            <Subtitle
              text={SUBTITLE.subtitle2}
              className={styles.description}
            />
            <Subtitle text={SUBTITLE.subtitle3} className={styles.question} />
          </div>

          <div className={styles.imageGolf}>
            <StaticImage
              src={"../../static/images/qdmarinha_golf-08.jpg"}
              alt={"golf"}
              objectFit="cover"
              objectPosition={"center"}
            />
          </div>
          <div className={styles.imageGolfD}>
            <StaticImage
              src={"../../static/images/qdmarinha_golf-08.jpg"}
              alt={"golf"}
              objectFit="cover"
              objectPosition={"center"}
              className={styles.imageD}
            />
          </div>
        </div>
      </div>

      <div className={styles.bannerD}>
        <Banner active={true} />
      </div>

      <div className={styles.sectionTwo}>
        <Title text={TITLE.title2} className={styles.programme} />
        <Card className={styles.card} />
      </div>

      <div className={styles.banner}>
        <Banner active={true} />
      </div>

      <div className={styles.sectionThree}>
        <Title text={TITLE.title3} className={styles.workshop} />

        <MapAccordion />
      </div>

      <div className={styles.sectionFour}>
        <Title text={TITLE.title4} className={styles.view} />
        <StyledLink
          link={programme}
          text={"download here"}
          className={styles.downloadButton}
          onClick={() => gtagSendEvent("download_program", "bottom")}
        />
      </div>

      <div className={styles.carousel}>
        <Title text={TITLE.carousel1} className={styles.dentistry} />
        <Carousel setSwiper={setSwiper} />
        <CarouselD setSwiper={setSwiperD} />
        <CarouselControls swiper={swiper} />
        <CarouselControlsD swiper={swiperD} />
      </div>

      <div className={styles.sectionFive}>
        <Title text={TITLE.title5} className={styles.resort} />

        <div className={styles.duoPic}>
          <div className={styles.carouselPic}>
            <CarouselPic setSwiper={setSwiperPic} />
          </div>
          <div className={styles.block}>
            <CarouselControlsPic
              swiper={swiperPic}
              className={styles.controlsPic}
            />
            <Text text={TEXT.text51} className={styles.ideal} />
            <Text text={TEXT.text52} className={styles.hotel} />
            <Text text={TEXT.text53} className={styles.hotel} />
          </div>
        </div>
      </div>
      <div className={styles.speciale}>
        <BannerD text={"Register now!"} active={false} />
      </div>

      <div className={styles.sectionSix}>
        <Title text={TITLE.title6} className={styles.resort} />
        <Text text={TEXT.text66} className={styles.grasRouge} />
        <div className={styles.section}>
          <Text text={TEXT.text67} className={styles.grasNoir} />
          <Text text={TEXT.text68} className={styles.asterix} />
          <a
            href={pdfinformation}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
          >
            <Text text={"more information"} className={styles.grasLien} />
          </a>
          <Text text={TEXT.text69} className={styles.asterix} />
        </div>
        <Price />
        <div className={styles.join}>
          <Text text={TEXT.text612} className={styles.normal} />
          <Text text={TEXT.text613} className={styles.bold} />
          <Text text={TEXT.text614} className={styles.normal} />
          <div className={styles.subgroup}>
            <Text text={TEXT.text615} className={styles.color} />
            <Text text={"."} />
          </div>
        </div>
        <div className={styles.prices}>
          <div className={styles.textPrice}>
            <Text text={TEXT.text62} className={styles.ideal} />
            <Text text={PRICE.price1} className={styles.price} />
          </div>
          <div className={styles.textPrice}>
            <Text text={TEXT.text63} className={styles.ideal} />
            <Text text={PRICE.price2} className={styles.price} />
          </div>
          <div className={styles.textPrice}>
            <Text text={TEXT.text64} className={styles.ideal} />
            <Text text={PRICE.price3} className={styles.price} />
          </div>
          <div className={styles.textPrice}>
            <Text text={TEXT.text65} className={styles.ideal} />
            <Text text={PRICE.price4} className={styles.price} />
          </div>
          <div></div>
        </div>
        <div className={styles.posButton}>
          <StyledLink
            link={" https://eao.org/eao-spring-break-2022/ "}
            text={"register now"}
            className={styles.downloadButton}
            onClick={() => gtagSendEvent("register", "bottom")}
          />
        </div>
      </div>

      <div className={styles.sectionSeven}>
        <Title text={TITLE.title7} className={styles.resort} />
        <Text text={TEXT.text7} className={styles.hotel} />
        <StyledLink
          link={pdfinformation}
          text={"view and download"}
          className={styles.downloadButton}
          onClick={() => gtagSendEvent("download", "useful_information")}
        />
      </div>

      <div className={styles.sectionHeigt}>
        <Link to="#top" className={styles.link}>
          <FontAwesomeIcon icon={faChevronCircleUp} className={styles.icon} />
        </Link>
      </div>

      <div className={styles.sectionNine}>
        <Contact />
        <ContactD />
      </div>
    </Layout>
  );
};

export default IndexPage;

export const gtagSendEvent = (action: string, label: string) => {
  typeof window !== "undefined" &&
    window.gtag &&
    window.gtag("event", action, {
      // 'event_category': <category>,
      event_label: label,
      value: 1,
    });
};
